import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import App from './App.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'react-tooltip/dist/react-tooltip.css';
import './apm/apm.js';
import Login from './components/Login.tsx';
import 'react-loading-skeleton/dist/skeleton.css';
import { Slide, ToastContainer } from 'react-toastify';
import { WebStorageStateStore } from 'oidc-client-ts';

const oidcConfig = {
  authority: `${process.env.AUTHENTIK_HOST}/application/o/mvr`,
  client_id: `${process.env.AUTHENTIK_CLIENT_ID}`,
  redirect_uri: `${process.env.CLIENT_APP_URL}/home`,
  scope: 'openid profile email roles goauthentik.io/api',
  client_secret: process.env.AUTHENTIK_CLIENT_SECRET,
  post_logout_redirect_uri: process.env.CLIENT_APP_URL,
  automaticSilentRenew: false,
  onSigninCallback: () => {
    window.history.replaceState({}, 'null', window.location.pathname);
  },
  metadata: {
    issuer: `${process.env.AUTHENTIK_HOST}/application/o/mvr/`,
    authorization_endpoint: `${process.env.AUTHENTIK_HOST}/application/o/authorize/`,
    token_endpoint: `${process.env.AUTHENTIK_HOST}/application/o/token/`,
    userinfo_endpoint: `${process.env.AUTHENTIK_HOST}/application/o/userinfo/`,
    end_session_endpoint: !!(window as any)?.ReactNativeWebView
      ? `${process.env.AUTHENTIK_HOST}/if/flow/mvr-app-invalidation-flow/`
      : `${process.env.AUTHENTIK_HOST}/if/flow/mvr-invalidation-flow/`,
    jwks_uri: `${process.env.AUTHENTIK_HOST}/application/o/mvr/jwks/`,
  },
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root')!);

const ACTIVE_THEME = process.env.VITE_THEME_TOGGLE ?? 'MVR_AU';

switch (ACTIVE_THEME) {
  case 'HeyDay':
    // import('./styles/heyday.css');
    break;
  case 'MedReleaf':
    import('./scss/medreleaf.scss');
    break;
  default:
    // import('./styles/mvr-au.css');
    break;
}

root.render(
  <div
    className={
      process.env.VITE_THEME_TOGGLE === 'HeyDay'
        ? 'heyday-wrapper'
        : process.env.VITE_THEME_TOGGLE === 'MedReleaf'
          ? 'medreleaf-wrapper'
          : 'mvr-wrapper'
    }
  >
    {/* <div className={'heyday-wrapper'}> */}
    {window.location.pathname === '/' ? (
      <Login />
    ) : (
      <AuthProvider {...oidcConfig}>
        <QueryClientProvider client={queryClient}>
          <ToastContainer limit={1} transition={Slide} hideProgressBar={true} />
          <App />
        </QueryClientProvider>
      </AuthProvider>
    )}
  </div>,
);
